/**
 * Created by fanglijuan 2017-5-19
 */
angular.module("typeclassifySettingPageManageServiceModule",[
"mgcNPaperAddTypeModule",
"mgcNPaperSortTypeModule"
    ])
    // .controller("typeclassifySettingPageManageServiceCtrl", ["$scope", "$modalInstance","title",'successFn',function ($scope, $modalInstance,title,successFn) {
    //     initData();
    //     $scope.cancel = function () {
    //         $scope.$close();
    //     };
    //     $scope.confirm = function () {
    //         $modalInstance.close({});
    //     };
    //     function initData(){
    //         $scope.title = title;
    //         $scope.successFn = successFn;
    //     }
    // }])
    .factory("typeclassifySettingPageManageService", ["$modal", "$q", "trsHttpService", "globleParamsSet", function($modal, $q, trsHttpService, globleParamsSet) {
        return {
            addType: function(params) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/typeClassifySettingPageManage/service/addType/addType_tpl.html",
                    windowClass: 'mgcNPaperDisConfigAddType ',
                    backdrop: false,
                    controller: "mgcNPaperAddTypeCtrl",
                    resolve: {
                        params: function() {
                            return params;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            sortType: function(type, curpos, selectedArray, array, confirm, cancel) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/typeClassifySettingPageManage/service/sortType/sortType_tpl.html",
                    windowClass: 'mgcNPaperDisConfigSortType ',
                    backdrop: false,
                    controller: "mgcNPaperSortTypeCtrl",
                    resolve: {
                        params: function() {
                            return {
                                type: type,
                                curpos: curpos,
                                selectedArray: selectedArray,
                                array: array
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
        };
    }]);